import { femaleLead, maleLead, type Character } from '@/mocks/galData';

interface CharacterCardProps {
  char: Character;
  reverse?: boolean;
  anchorId: string;
}

function CharacterCard({ char, reverse, anchorId }: CharacterCardProps) {
  return (
    <article
      id={anchorId}
      className="grid scroll-mt-24 grid-cols-1 items-center gap-6 overflow-hidden rounded-3xl border border-background-200 bg-background-50 p-4 shadow-soft md:p-6 lg:grid-cols-[5fr_6fr]"
    >
      <div className={`relative overflow-hidden rounded-2xl ${reverse ? 'lg:order-2' : ''}`}>
        <img
          src={char.image}
          alt={`${char.name} ${char.role}角色立绘`}
          className="h-72 w-full object-cover object-top md:h-96"
        />
        <span className="absolute left-4 top-4 rounded-full bg-background-50/90 px-3 py-1 text-xs text-primary-700">
          {char.role}
        </span>
      </div>

      <div className={reverse ? 'lg:order-1' : ''}>
        <p className="text-sm text-primary-600">{char.tagline}</p>
        <h3 className="mt-2 flex flex-wrap items-center gap-3 font-heading text-2xl text-foreground-950 md:text-3xl">
          {char.name}
          <span className="text-base text-foreground-600">#{char.alias}</span>
        </h3>

        <ul className="mt-4 flex flex-wrap gap-2">
          {char.traits.map((trait) => (
            <li
              key={trait}
              className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800"
            >
              {trait}
            </li>
          ))}
        </ul>

        <p className="mt-5 text-sm leading-7 text-foreground-700 md:text-base">
          {char.intro}
        </p>

        <dl className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {[
            { label: '年龄', value: char.age },
            { label: '身高', value: char.height },
            { label: '最爱', value: char.color },
            { label: '爱好', value: char.hobby },
          ].map((item) => (
            <div
              key={item.label}
              className="rounded-xl bg-background-100 px-3 py-2.5"
            >
              <dt className="text-xs text-foreground-600">{item.label}</dt>
              <dd className="mt-0.5 text-sm font-medium text-foreground-950">
                {item.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </article>
  );
}

export default function Characters() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 text-center">
          <span className="inline-block rounded-full bg-accent-100 px-4 py-1.5 text-sm text-accent-700">
            核心角色
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
            女主是谁 · 男主设定，一眼看懂
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-700 md:text-base">
            这是整部作品的主角二人组。下面分别介绍泡在我家的辣妹女主与男主的完整人设，帮你快速抓住角色性格。
          </p>
        </div>

        <div className="flex flex-col gap-6">
          <CharacterCard char={femaleLead} anchorId="female-lead" />
          <CharacterCard char={maleLead} anchorId="male-lead" reverse />
        </div>
      </div>
    </section>
  );
}